var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-tabbar',{attrs:{"route":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('van-tabbar-item',{attrs:{"icon":"home-o","to":"/home"}},[_vm._v("首页")]),_c('van-tabbar-item',{attrs:{"icon":"contact-o","to":"/mine"}},[_vm._v("我的")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }